import React from 'react';

export function checkPasswordStrength(password) {
  const checks = {
    length:    password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    number:    /[0-9]/.test(password),
    special:   /[^A-Za-z0-9]/.test(password),
  };
  const score = Object.values(checks).filter(Boolean).length;
  return { checks, score, valid: checks.length && checks.uppercase && checks.number };
}

export function validatePassword(password) {
  const { valid, checks } = checkPasswordStrength(password);
  if (!valid) {
    if (!checks.length)    return 'Password must be at least 8 characters';
    if (!checks.uppercase) return 'Password must contain at least one uppercase letter';
    if (!checks.number)    return 'Password must contain at least one number';
  }
  return null;
}

export default function PasswordStrength({ password }) {
  if (!password) return null;
  const { checks, score } = checkPasswordStrength(password);

  const colors = ['#D63A3A', '#E8A020', '#1B8FD4', '#0FA86A'];
  const labels = ['Weak', 'Fair', 'Good', 'Strong'];
  const color  = colors[score - 1] || '#D63A3A';
  const label  = labels[score - 1] || 'Weak';

  return (
    <div style={{ marginTop: 6 }}>
      {/* Strength bars */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 5 }}>
        {[1,2,3,4].map(i => (
          <div key={i} style={{
            flex: 1, height: 4, borderRadius: 2,
            background: i <= score ? color : 'var(--border)',
            transition: 'background 0.2s',
          }} />
        ))}
      </div>
      {/* Checklist */}
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        {[
          { key: 'length',    label: '8+ chars' },
          { key: 'uppercase', label: 'Uppercase' },
          { key: 'number',    label: 'Number' },
          { key: 'special',   label: 'Special char' },
        ].map(({ key, label }) => (
          <span key={key} style={{
            fontSize: 10, fontWeight: 500,
            color: checks[key] ? '#0FA86A' : 'var(--muted)',
          }}>
            {checks[key] ? '✓' : '○'} {label}
          </span>
        ))}
        <span style={{ fontSize: 10, fontWeight: 700, color, marginLeft: 'auto' }}>{label}</span>
      </div>
    </div>
  );
}
